import React from 'react'
import Hero from '../Components/Hero/Hero'
import Collection from '../Components/Collection/Collection'
import Popular from '../Components/Popular/Popular'
import Patterns from '../Components/Patterns/Patterns'
import Accessories from '../Components/Accessories/Accessories'
import Intro from '../Components/Intro/Intro'

const Home = () => {
  return (
    <div>
      <Intro />
      <Popular />
      <Hero />
      <Patterns />
      <Accessories />
      <Collection />
    </div>
  )
}

export default Home